


















































































// https://mae.chab.in/archives/60167
import { Component, Vue } from 'vue-property-decorator';
import { NSStoreEmployeeState } from '@/store/modules/employee';
import JobOfferCarousel from '@/containers/JobOfferCarousel.vue';
import JobOfferFilterConditionForm from '@/containers/JobOfferFilterConditionForm.vue';
import { jobOfferType } from '@/types/jobOffer';

@Component({
  components: {
    JobOfferCarousel,
    JobOfferFilterConditionForm
  }
})
export default class Employee extends Vue {
  currentTabId: string = jobOfferType.ALLJOB;

  moutned() {
    this.currentTabId = this.$store.getters['jobOfferCurrentType'];
  }

  /**
   * 絞り込み適用後の求人データを取得する
   * @return Offer[]
   */
  public get filteredOffers() {
    // https://qiita.com/sutoh/items/7e0bd63f9cb47bf48db9#thisstoregetters-%E3%81%AE%E5%91%BC%E3%81%B3%E5%87%BA%E3%81%97
    return this.$store.getters[this.currentTabId + '/filteredOffers'];
  }

  /**
   * 絞り込みした後の全件数を返す
   * @return Number
   */
  public get filteredOffersLength(): number {
    return this.$store.getters[this.currentTabId + '/filteredOffersLength'];
  }

  /**
   * 現在の絞り込み条件を取得する
   */
  public get filterQuery() {
    return this.$store.getters[this.currentTabId + '/filterQuery'];
  }

  public get filterQueryConditions() {
    return this.$store.getters[this.currentTabId + '/filterQueryConditions'];
  }

  public get currentPageNumber() {
    return this.$store.getters[this.currentTabId + '/currentPageNumber'];
  }

  public get currentPageItemIndexFrom(): number {
    return this.$store.getters[this.currentTabId + '/currentPageItemIndexFrom'];
  }

  public get currentPageItemIndexTo(): number {
    return this.$store.getters[this.currentTabId + '/currentPageItemIndexTo'];
  }

  /**
   * 絞り込みUIからemitした条件をもとにStoreに反映する
   */
  handleFilterQuery(filterQuery: NSStoreEmployeeState.filterQuery): void {
    // this.setFilterQuery(filterQuery);
    this.$store.dispatch(this.currentTabId + '/setFilterQuery', filterQuery);

    // 絞り込みに変更が起きたら1ページ目に戻す
    this.$store.dispatch(this.currentTabId + '/setCurrentPageNumber', 0);
  }

  /**
   * 画面に表示する求人の種類を変更する
   */
  handleChangeJobOfferType(e: Event) {
    e.preventDefault();
    if (e.target) {
      const target = e.target as HTMLElement;
      const selected = target.getAttribute('aria-controls') as string;
      if (selected) {
        this.currentTabId = selected;
      }
    }
  }

  /**
   * swiper.paginationの動作に依存しているため、新しいindexがemitされてきたらStoreに反映する
   * @param index
   */
  handleChangeSlide(index: number): void {
    this.$store.dispatch(this.currentTabId + '/setCurrentPageNumber', index);
  }
}
